import { Image } from "@oxygen/core";
import getThemeClasses from "@oxygen/theme";
import { CSSFlex } from "GlobalComponent/CSSCore";
import { DEFAULT_AREA_ID, DEFAULT_AREA_NAME } from "GlobalConstant/Location";
import { fireInteractiveTracking } from "GlobalUtils/Analytics";
import React, { memo } from "react";
import styles from "./scss/PopularCities.module.scss";

const cityContainerClasses = getThemeClasses(`
  flex-direction-column;
  align-items-center;
  mb-5 md:mb-8;
`);
const imageContainerClass = getThemeClasses(`
  cursor-pointer;
`);
const cityNameClasses = getThemeClasses(`
  mt-2;
  font-size-6.5;
`);

const City = ({ city = {}, onCityClick }) => {
  const handlePopularCityClick = () => {
    fireInteractiveTracking("AreaLocation", "PopularCity Click", city.cityName);
    onCityClick({
      ...city,
      areaId: DEFAULT_AREA_ID,
      areaName: DEFAULT_AREA_NAME,
    });
  };
  const { cityName, imagePath } = city;
  if (!cityName || !imagePath) {
    return null;
  }
  return (
    <CSSFlex
      className={`${cityContainerClasses} ${styles.cityContainer}`}
      onClick={handlePopularCityClick}
    >
      <div className={`${imageContainerClass} ${styles.imageContainer}`}>
        <Image
          src={imagePath}
          description={cityName}
          aspectRatio="16:9"
          data-testing-id={cityName}
        />
      </div>
      <span className={cityNameClasses}>{cityName}</span>
    </CSSFlex>
  );
};

const containerClasses = getThemeClasses(`
  pl-0 md:pl-7;
  pr-0 md:pr-7;
  pb-2 md:pb-0;
`);
const headingClasses = getThemeClasses(`
  display-block;
  font-weight-bold;
  font-size-8;
  mb-5 md:mb-4;
  ml-5 md:ml-4;
`);
const citiesWrapperClasses = getThemeClasses(`
  justify-content-center;
  flex-wrap-wrap;
`);
export const PopularCities = memo(function PopularCities({
  cities,
  onCityClick,
}) {
  if (!cities || !cities.length) {
    return null;
  }
  return (
    <div className={containerClasses}>
      <span className={headingClasses}>Popular Cities</span>
      <CSSFlex className={citiesWrapperClasses}>
        {cities.map(city => (
          <City city={city} onCityClick={onCityClick} key={city.cityId} />
        ))}
      </CSSFlex>
    </div>
  );
});
PopularCities.displayName = "PopularCities";
